"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutboundWebhookAuthTypes = void 0;
var OutboundWebhookAuthTypes;
(function (OutboundWebhookAuthTypes) {
    OutboundWebhookAuthTypes["OAUTH"] = "oauth";
    OutboundWebhookAuthTypes["USER_PASSWORD"] = "user_password";
    OutboundWebhookAuthTypes["BASIC"] = "basic";
    OutboundWebhookAuthTypes["NONE"] = "none";
    OutboundWebhookAuthTypes["DIRECIONAL_PERMUTAS"] = "direcional_permutas";
})(OutboundWebhookAuthTypes = exports.OutboundWebhookAuthTypes || (exports.OutboundWebhookAuthTypes = {}));
